import Enum from "./Enum";

export default Enum.create( {
	ZOOM: "ZOOM",
	MICROSOFT_TEAMS: "MICROSOFT_TEAMS",
	GOOGLE_MEET: "GOOGLE_MEET",
} );
